import React from 'react';

import { t } from 'state/intl/translations';

import { LoggedOutEmptyStateImage } from './images';
import { EmptyStateWrapper, HeaderText, ImageWrapper, SubText } from './styled';

const NoFavoritesEmptyState = () => {
  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <LoggedOutEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{t('noFavoritesHeader')}</HeaderText>
      <SubText>{t('noFavoritesSubheader')}</SubText>
    </EmptyStateWrapper>
  );
};

export default NoFavoritesEmptyState;
